import { z } from 'zod';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';
import { SChatMember } from './chat-member';

const SChatMessageAttachment = z.object({
  id: z.number(),
  file_url: z.string(),
  thumbnail_url: z.string().nullable(),
  type: z.string(),
  file_size: z.number(),
  file_name: z.string(),
  file_extension: z.string().nullable(),
});
export type TChatMessageAttachment = z.infer<typeof SChatMessageAttachment>;

export const SChatMessage = z.object({
  id: z.int(),
  content: z.string().nullable(),
  content_type: z.string(),
  sender: SChatMember,
  attachments: z.array(SChatMessageAttachment).nullable(),
  sent_at: z.coerce.date(),
  from_me: z.boolean(),
});
export type TChatMessage = z.infer<typeof SChatMessage>;

export const SChatMessageResponse = createStandardResponse(SChatMessage);
export type TChatMessageResponse = z.infer<typeof SChatMessageResponse>;

export const SChatMessagesResponse = createStandardResponse(
  z.array(SChatMessage)
);
export type TChatMessagesResponse = z.infer<typeof SChatMessagesResponse>;
